module.exports = __webpack_public_path__ + "img/pdf-download.128f5020.png";